import actions from './actions'
import type { MessageToAccountantReducerAction } from './types'

export const initialState: MessageToAccountantStore = {
  isSlideOverOpen: false,
  topics: {
    data: [],
    loading: false,
    fetched: false,
    error: null,
  },
}

export default function reducer(
  state: MessageToAccountantStore = initialState,
  action: MessageToAccountantReducerAction
): MessageToAccountantStore {
  switch (action.type) {
    case actions.fetchMessageToAccountantTopics.REQUEST:
      return {
        ...state,
        topics: {
          ...state.topics,
          loading: true,
          fetched: false,
        },
      }

    case actions.fetchMessageToAccountantTopics.SUCCESS:
      return {
        ...state,
        topics: {
          data: action.payload,
          loading: false,
          fetched: true,
          error: null,
        },
      }

    case actions.setSlideOverOpen.REQUEST:
      return {
        ...state,
        isSlideOverOpen: action.payload,
      }

    case actions.fetchMessageToAccountantTopics.FAILURE:
      return {
        ...state,
        topics: {
          ...state.topics,
          loading: false,
          error: action.payload,
        },
      }

    default:
      return state
  }
}
